export type PointLike = { _x: number; _y: number };
export class ImageWithLandMark {
  constructor(image: HTMLImageElement, results?: Array<PointLike> | undefined) {
    this.image = image;
    this.results = results ?? null;
  }

  public image: HTMLImageElement;
  public results: Array<PointLike> | null;
}
